import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const ordersApi = createApi({
    reducerPath: 'ordersApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedOrdersApi = ordersApi.injectEndpoints({
    endpoints: (builder) => ({
        ordersList: builder.mutation({
            query: (config) => ({
                url: '/Orders/searchweb',
                method: 'POST',
                body: config,
            }),
        }),
        ordersCount: builder.mutation({
            query: (config) => ({
                url: '/Orders/count',
                method: 'POST',
                body: config,
            }),
        }),
        ordersAdd: builder.mutation({
            query: (config) => ({
                url: '/Orders/addmultiple',
                method: 'POST',
                body: config,
            }),
        }),
        ordersedit: builder.mutation({
            query: (config) => ({
                url: '/Orders/modify',
                method: 'POST',
                body: config,
            }),
        }),
        addOpticBox: builder.mutation({
            query: (config) => ({
                url: '/Orders/addopticbox',
                method: 'POST',
                body: config,
            }),
        }),
        statusChange: builder.mutation({
            query: (config) => ({
                url: '/Orders/ChangeStatus',
                method: 'POST',
                body: config,
            }),
        }),
        orderExport: builder.mutation({
            query: (config) => ({
                url: `/Orders/Export?status=${config}`,
                method: 'POST',
            }),
        }),
    }),
    overrideExisting: false,
});
export const {
    useOrdersListMutation,
    useOrdersAddMutation,
    useOrderExportMutation,
    useOrdersCountMutation,
    useStatusChangeMutation,
    useOrderseditMutation,
    useAddOpticBoxMutation,
} = injectedOrdersApi;
export default ordersApi;
